export type UserUniqueIdObjectPrefix = "DXP-" | "DXC-" | "DXW-" | "CDXP-" | "CDXC-" | "CDXZ-";

// TODO: Refactor usages and use getPanelUserUniqueIdPrefix where it's possible, when function is merged to master
export const getPanelUserUniqueIdObjectPrefix = (): UserUniqueIdObjectPrefix => "DXP-";
export const getCornerUserUniqueIdObjectPrefix = (): UserUniqueIdObjectPrefix => "DXC-";
export const getCustomPanelUserUniqueIdObjectPrefix = (): UserUniqueIdObjectPrefix => "CDXP-";
export const getCustomCornerUserUniqueIdObjectPrefix = (): UserUniqueIdObjectPrefix => "CDXC-";
export const getCustomZShapedPanelUniqueIdObjectPrefix = (): UserUniqueIdObjectPrefix => "CDXZ-";
